import React from "react";
import { abbreviateNumber } from "@utility/index";
import UserAvatar from "@components/userComponents/UserAvatar";
import { useRouter } from "next/router";

export default function UserDetails({ user, setShareLinksModal }) {
  return (
    <header className="w-full flex flex-col items-center ">
      <div className="max-w-full w-96 py-6 ">
        <HeaderAvatar user={user} />
        <HeaderBody user={user} />
        <UserProfileDescription user={user} />
        {user.isPrivate === false ? (
          <UserStatisticsInfo user={user} />
        ) : (
          <AccountIsPrivateText />
        )}
        <ShareBody setShareLinksModal={setShareLinksModal} />
      </div>
    </header>
  );
}

// User Details Components

function AccountIsPrivateText() {
  return (
    <div className="py-2 flex-col flex items-center justify-center ">
      <span className="text-gray-400">This account is private.</span>
    </div>
  );
}
function UserProfileDescription({ user }) {
  return (
    <div className="py-2 flex-col flex items-center justify-center">
      <span>{user?.profileDescription}</span>
    </div>
  );
}
function UserStatisticsInfo({ user }) {
  return (
    <div className="py-4 div flex-row flex items-center justify-evenly">
      <div className=" flex flex-row  justify-start ">
        <span className="text-sm pr-2 font-semibold">
          {abbreviateNumber(user?.followingCount)}
        </span>
        <span className="text-sm text-gray-400">Following</span>
      </div>
      <div className="flex flex-row  justify-start ">
        <span className="text-sm pr-2 font-semibold">
          {abbreviateNumber(user?.followerCount)}
        </span>
        <span className="text-sm text-gray-400">Followers</span>
      </div>
      <div className=" flex flex-row  justify-start ">
        <span className="text-sm pr-2 font-semibold">
          {abbreviateNumber(user?.postLikeCount)}
        </span>
        <span className="text-sm text-gray-400">Likes</span>
      </div>
      <div className="flex flex-row  justify-start">
        <span className="text-sm pr-2 font-semibold">
          {abbreviateNumber(user?.postViewCount)}
        </span>
        <span className="text-sm text-gray-400">Views</span>
      </div>
    </div>
  );
}

function HeaderBody({ user }) {
  return (
    <div className="py-2 div flex-col flex items-center justify-center">
      <span className=" text-3xl">{user?.name}</span>
      <span className="text-lg">@{user?.username}</span>
    </div>
  );
}

function ShareBody({ setShareLinksModal }) {
  return (
    <div className="py-2 div flex-col flex items-center justify-center">
      <button
        onClick={setShareLinksModal}
        className="bg-gray-100 px-8 py-1 rounded-sm border border-gray-300 ripple text-[14px]"
        type="button"
      >
        Share
      </button>
    </div>
  );
}

function HeaderAvatar({ user }) {
  const router = useRouter();

  const handleAvatarClick = () => {
    router.push(`/post/${user.avatarPostId}`);
  };

  return (
    <div className=" py-4 flex justify-center">
      <UserAvatar
        handleClick={handleAvatarClick}
        user={user}
        active
        size="xxxl"
      />
    </div>
  );
}
